<form [formGroup]="mapForm" class="layout-form">
  <br />
  <br />
  <br />
  <br />
  <div class="form-header">
    <p>Confirme seu endereço</p>
  </div>
  <ng-container *ngIf="mapOptions.center && markerPosition && apiLoaded | async">
    <div class="map" [attr.data-testid]="'mapa'">
      <google-map
        (mapClick)="mapClick($event)"
        (zoomChanged)="zommChangedMap()"
        [options]="mapOptions"
        [zoom]="zoom"
        height="100%"
        width="100%"
      >
        <map-marker *ngIf="markerPosition" [position]="markerPosition"></map-marker>
      </google-map>
    </div>

    <div class="map-input-container">
      <div class="parent-column">
        <div class="parent">
          <div class="map-input-container-street">
            <app-text-input
              id="map-confirm-street-input"
              [attr.data-testid]="'direction'"
              [placeholder]="'Confirme sua localização'"
              [labelText]="'Confirme sua localização'"
              formControlName="locationStreet"
              [required]="true"
              (input)="onChangeStreet($event)"
              [submitted]="submitted || showErrorConfirm"
            ></app-text-input>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <br />
  <div class="form-navigation pad">
    <app-navigation [currentStep]="2" [countSteppers]="5"></app-navigation>
  </div>

  <div class="button-container">
    <button mat-raised-button class="back-button" type="button" (click)="back()">Voltar</button>
    <button id="continue-button" mat-raised-button class="next-button" type="submit" (click)="onSubmit()">
      Seguindo
    </button>
  </div>
</form>
